  let questionsf = document.querySelectorAll(".questionsf");
  questionsf.forEach(questionsf => {
    questionsf.addEventListener("click", event => {
      // const active = document.querySelector(".questionsf.active");
      // if (active && active !== questionsf) {
      //   questionsf.classList.toggle("active");
      //   questionsf.nextElementSibling.style.maxHeight = 0;
      // }
      // questionsf.classList.toggle("active");
      // const answersf = questionsf.nextElementSibling;
      // if (questionsf.classList.contains("active")) {
      //   answersf.style.maxHeight = answersf.scrollHeight + "px";
      // } else {
      //   //answersf.style.maxHeight = 0;
      // }
      questionsf.classList.toggle("active");
      questionsf.nextElementSibling.style.maxHeight = questionsf.nextElementSibling.scrollHeight + "px";
      
      if (!questionsf.classList.contains("active")) {
        questionsf.nextElementSibling.style.maxHeight = 0;
      } else {
        
      }
      
    })
  })